export const appConfig = {
//   apiUrl:
//     window.location.origin.includes('sby') ||
//     window.location.origin.includes('compleyes')
//       ? window.location.origin.includes('dev')
//         ? 'https://api.compleyes.com'
//         : 'https://api.compleyes.com'
//       : 'http://localhost:8081',
//   'https://api.sbykatzlaw.com'
  apiUrl: process.env.REACT_APP_API_URL
};
